export default __webpack_public_path__ + "static/media/analysis-report-card.1709d546.svg";